import { toast } from 'react-toastify'
import * as api from 'helpers/api'

/** Fetches a file from the backend and downloads it under the given filename. */
export const downloadApiFile = async (
  url: string,
  filename: string,
  type: string,
  successMessage: string,
  errorMessage: string,
): Promise<void> => {
  try {
    const result = await api.get(url, undefined, true)
    const blobUrl = URL.createObjectURL(new Blob([result], { type }))

    const link = document.createElement('a')
    link.href = blobUrl
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    URL.revokeObjectURL(blobUrl)
    toast.success(successMessage)
  } catch (e: any) {
    let message = errorMessage

    if (e?.response?.data instanceof ArrayBuffer) {
      try {
        message = JSON.parse(new TextDecoder().decode(e.response.data))?.message || message
      } catch {
        // keep default message
      }
    }

    toast.error(message)
  }
}

/** Fetches an EOB PDF from the backend and downloads it under the given filename. */
export const downloadEobPdf = (url: string, filename: string): Promise<void> =>
  downloadApiFile(
    url,
    filename,
    'application/pdf',
    'EOB document downloaded',
    'Failed to generate the EOB document',
  )
